import { Product } from 'core/types/product';

import usePaginationHandler from './usePaginationHandler';

export default function useProductList(searchParams: any) {
  return usePaginationHandler<Product>('products/list', searchParams);
}
